import { render, staticRenderFns } from "./ExtensionAdmin.vue?vue&type=template&id=7cefe7b9&scoped=true&"
import script from "./ExtensionAdmin.vue?vue&type=script&lang=ts&"
export * from "./ExtensionAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cefe7b9",
  null
  
)

export default component.exports